import _get from 'lodash/get';

import { ShareholderComments } from '@/models';

export class LandlordComments extends ShareholderComments {

}
